<template>
  <router-view />
</template>

<script>
export default {
  name: "Search",
};
</script>

<style>
</style>